import React from 'react';
import { ArcStack, ArcTab, ArcTabContext, ArcTabs } from '@src/core/ui';
import { DEFAULT_FLEET_TAB, FLEET_TABS } from '../../constants';
import { PanelWrapperProps } from './types';

const PanelWrapper: React.FC<PanelWrapperProps> = (props) => {
  const { children } = props;
  const [tab, setTab] = React.useState<string>(DEFAULT_FLEET_TAB);

  const onChange = (_: React.SyntheticEvent, value: string) => setTab(value);

  return (
    <ArcStack p={2} mt={2.3} borderRadius={1} bgcolor='background.paper'>
      <ArcTabContext value={tab}>
        <ArcTabs
          value={tab}
          onChange={onChange}
          variant='fullWidth'
          TabIndicatorProps={{ sx: { bgcolor: 'brand.main' } }}>
          {FLEET_TABS.map(({ value, label }) => (
            <ArcTab key={value} value={value} label={label} />
          ))}
        </ArcTabs>
        {children}
      </ArcTabContext>
    </ArcStack>
  );
};

export default PanelWrapper;